import { Map, List } from 'immutable';
import createReducer from './utils/createReducer';
import { DELETE_NODE, CLEAR_SCENE } from './actionTypes';

const SELECT_NODE = 'SELECT_NODE';
const DESELECT_ALL = 'DESELECT_ALL';
const SET_HIGHLIGHTING = 'SET_HIGHLIGHTING';

/**
 * Controls selection
 *
 * @module selection
 * @public
 */

const initialState = Map({
  nodes: List(),
  highlightNodes: false,
});

const reducer = createReducer(initialState, {
  [SELECT_NODE](state, nodeId) {
    const nodes = state.get('nodes');
    return state.set('nodes', !nodes.includes(nodeId) ? nodes.clear().push(nodeId) : nodes);
  },

  [DELETE_NODE](state, nodeId) {
    let idx = state.get('nodes').indexOf(nodeId);
    return idx === -1 ? state : state.deleteIn(['nodes', idx]);
  },

  [CLEAR_SCENE](state) {
    return state.set('nodes', state.get('nodes').clear());
  },

  [DESELECT_ALL](state) {
    return state.set('nodes', state.get('nodes').clear());
  },

  [SET_HIGHLIGHTING](state, highlight) {
    return state.set('highlightNodes', highlight);
  },
});

export function selectNode(nodeId) {
  return { type: SELECT_NODE, payload: nodeId };
};

export function isSelected(store, nodeId) {
  return store.getIn(['selection', 'nodes']).includes(nodeId);
};

export function lastSelectedNode(store) {
  return store.getIn(['selection', 'nodes']).last();
};

export function getSelectedNodes(store) {
  return store.getIn(['selection', 'nodes']).toArray();
};

export function deselectAll() {
  return { type: DESELECT_ALL };
};

export function setHighlighting(highlight) {
  return { type: SET_HIGHLIGHTING, payload: highlight };
};

export function isHighlighting(store) {
  return store.getIn(['selection', 'highlightNodes']);
}

const publicApi = {
  reducer,
  actions: { selectNode, deselectAll, setHighlighting },
  selectors: { isSelected, lastSelectedNode },
};
export default publicApi;



// WEBPACK FOOTER //
// ./src/modules/selection.js